import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, RefreshCwIcon, ThumbsUpIcon } from 'lucide-react';
const POINTS = [{
  icon: ShieldCheckIcon,
  title: 'Fully insured on every job',
  desc: 'If anything goes wrong — to your property, your system, anything — you\u2019re covered. Professionally insured, not "trust me" insured.'
}, {
  icon: RefreshCwIcon,
  title: 'We stand behind our work',
  desc: 'If something we installed or repaired fails, we come back and make it right. Period.'
}, {
  icon: ThumbsUpIcon,
  title: 'Zero risk to you',
  desc: 'You take no risk calling us. You take a very real risk calling someone else.'
}];
export function GuaranteeSection() {
  return <section id="why" className="w-full bg-white py-16 sm:py-24" data-id="element-131" data-mp="xkgrd449p2ow">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-132" data-mp="xlrxvbp3kojp">
        <div className="mx-auto max-w-3xl text-center" data-id="element-133" data-mp="12kbnbm2wgigt">
          <span className="text-xs font-bold uppercase tracking-wide text-nfgreen-dark" data-id="element-134" data-mp="17hv7f2ma3pgo">
            Zero-Risk
          </span>
          <h2 className="mt-3 font-display text-3xl font-extrabold text-slate-900 sm:text-4xl" data-id="element-135" data-mp="25syjqqmtreg6">
            Here's what makes this a zero-risk decision
          </h2>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-136" data-mp="1vt7qesa035ho">
          {POINTS.map((point, i) => <motion.div key={point.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-slate-200 bg-slate-50 p-7 text-center" data-id="element-137" data-mp="1rsfetsdnooi8" data-mpi={i}>
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-nfgreen text-white" data-id="element-138" data-mp="2ar055i7q3put">
                <point.icon className="h-7 w-7" data-id="element-139" data-mp="379fx95wgt2z5" />
              </div>
              <h3 className="mt-5 font-display text-xl font-bold text-slate-900" data-id="element-140" data-mp="37ar0n4m008pq">
                {point.title}
              </h3>
              <p className="mt-2 text-slate-600" data-id="element-141" data-mp="10k464n0qjsb0">{point.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}